import SnowBL from '../_assets/board-snow-bl.svg?react';
import SnowBottom from '../_assets/board-snow-bottom.svg?react';
import SnowBR from '../_assets/board-snow-br.svg?react';
import SnowTop from '../_assets/board-snow-top.svg?react';
import woodBottom from '../_assets/wood-bottom.svg';
import woodLeft from '../_assets/wood-left.svg';
import woodRight from '../_assets/wood-right.svg';
import woodTop from '../_assets/wood-top.svg';

import { RulesCard } from './RulesCard.tsx';

export const Board = () => {
  return (
    <div
      className="isolate mx-auto mt-auto mb-3 grid w-full max-w-2xl [--thickness:20px] sm:[--thickness:32px]"
      style={{
        gridTemplateAreas: `
          "left top right"
          "left main right"
          "left bottom right"
          "left under right"
        `,
        gridTemplateColumns: 'auto 1fr auto',
        gridTemplateRows: 'auto auto auto 1fr',
      }}
    >
      <div className="-z-10 bg-yellow-300" style={{ gridArea: 'main' }}>
        <RulesCard />
      </div>
      <div className="h-10 lg:h-36" style={{ gridArea: 'under' }} />
      <div
        className="-mx-px h-(--thickness)"
        style={{
          gridArea: 'bottom',
          backgroundImage: `url("${woodBottom}")`,
          backgroundSize: '100% 100%',
        }}
      />
      <div
        className="relative -mx-px grid h-[calc(var(--thickness)*2)] place-items-center"
        style={{
          gridArea: 'top',
          backgroundImage: `url("${woodTop}")`,
          backgroundSize: '100% 100%',
          boxShadow: 'rgba(0, 0, 0, 0.25) 0px 1px 3px 1px',
          clipPath: 'inset(0 0 -15px 0)',
        }}
      >
        <h2
          className="absolute right-0 left-0 -z-10 mx-auto text-center text-xl font-bold text-white [--stroke:2px] lg:text-4xl lg:[--stroke:4px]"
          style={{ WebkitTextStroke: 'var(--stroke) rgba(100, 58, 10, 1)' }}
        >
          Gjeldvettreglene
        </h2>
        <h2 className="text-xl font-bold text-white lg:text-4xl">Gjeldvettreglene</h2>
      </div>

      {/* Right wood & shadow */}
      <div
        style={{
          gridRow: '1 / -2',
          gridColumn: '3 / -1',
          boxShadow: 'rgba(0, 0, 0, 0.25) -1px 0px 3px 1px',
          clipPath: 'inset(0 0 0 -15px)',
        }}
      />
      <div
        className="z-10 w-(--thickness) rounded-tr-lg"
        style={{
          gridArea: 'right',
          backgroundImage: `url("${woodRight}")`,
          backgroundSize: '100% 100%',
        }}
      />
      <SnowBR
        className="z-10 mt-auto -mb-4 ml-auto h-auto translate-x-1/2"
        style={{ gridColumn: '2 / 4', gridRow: '4' }}
      />

      {/* Left wood & shadow */}
      <div
        style={{
          gridRow: '1 / -2',
          gridColumn: '1',
          boxShadow: 'rgba(0, 0, 0, 0.25) 1px 0px 3px 1px',
          clipPath: 'inset(0 -15px 0 0)',
        }}
      />
      <div
        className="z-10 w-(--thickness) rounded-tl-lg"
        style={{
          gridArea: 'left',
          backgroundImage: `url("${woodLeft}")`,
          backgroundSize: '100% 100%',
        }}
      />
      <SnowBL
        className="z-10 mt-auto mr-auto -mb-4 h-auto -translate-x-1/3"
        style={{ gridColumn: '1 / 3', gridRow: '4' }}
      />

      <SnowTop
        className="z-10 -mt-3.5 -mr-2 ml-auto h-auto max-w-full"
        style={{ gridColumn: '1 / -1', gridRow: '1' }}
        preserveAspectRatio="none"
      />
      <SnowBottom
        className="z-10 -mt-1.5 -mr-2 ml-auto"
        style={{ gridColumn: '2', gridRow: '3' }}
      />
    </div>
  );
};
